var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcomDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275,
    y: 0.275,
    width: 21.45,
    height: 21.45,
    rx: 10.725,
    stroke: "#43419E",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zak2gzhtda)",
    fill: "#43419E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.268 9.215h-3.077l-1.375 1.375h2.411c.128 0 .253.031.367.09l1.674-1.465zM11.276 15.54h1.1v.55h-1.1v-.55zM17.052 11.415v5.062l1.567-1.568a.269.269 0 0 0 .083-.194V9.566l-1.725 1.51c.049.106.074.222.075.34zM9.544 17.108l.005-.005a.275.275 0 0 0 .078-.191v-5.5a.275.275 0 0 0-.275-.275H3.577a.275.275 0 0 0-.275.275v5.5c0 .152.123.275.275.275h5.775a.273.273 0 0 0 .192-.079zm-3.492-1.021a.55.55 0 0 1-.55.55h-1.1a.55.55 0 0 1-.55-.55v-.55a.55.55 0 0 1 .55-.55h1.1a.55.55 0 0 1 .55.55v.55zm2.75.55h-.825a.275.275 0 1 1 0-.55h.825a.275.275 0 1 1 0 .55zm0-1.1h-.825a.275.275 0 1 1 0-.55h.825a.275.275 0 1 1 0 .55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.401 15.54h1.1v.55h-1.1v-.55zM16.416 17.11l.003-.006.005-.005a.275.275 0 0 0 .078-.187v-5.5a.275.275 0 0 0-.275-.275h-5.775a.275.275 0 0 0-.275.275v5.5c0 .152.123.275.275.275h5.775c.07 0 .138-.028.19-.078zm-3.49-1.023a.55.55 0 0 1-.55.55h-1.1a.55.55 0 0 1-.55-.55v-.55a.55.55 0 0 1 .55-.55h1.1a.55.55 0 0 1 .55.55v.55zm2.75.55h-.824a.275.275 0 0 1 0-.55h.825a.275.275 0 0 1 0 .55zm0-1.1h-.824a.275.275 0 0 1 0-.55h.825a.275.275 0 0 1 0 .55zM13.294 4.078l1.674-1.465h-2.222l-1.768 1.375h1.949c.128.001.253.032.367.09zM9.712 2.692a.274.274 0 0 1-.039.033L7.875 3.988h2.208l1.768-1.375H9.903a.267.267 0 0 0-.191.08zM15.32 8.306a.27.27 0 0 0 .082-.192v-5.15l-1.725 1.51c.049.107.075.222.075.34v5.062l1.567-1.57zM6.137 9.294a.275.275 0 0 1-.04.033L4.3 10.59h2.078a.815.815 0 0 1-.05-.275v-1.1a.267.267 0 0 0-.191.079zM7.977 8.938h1.1v.55h-1.1v-.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.152 10.59h5.775a.274.274 0 0 0 .192-.08l.006-.005a.274.274 0 0 0 .077-.19v-5.5a.275.275 0 0 0-.275-.276H7.152a.275.275 0 0 0-.275.275v5.5c0 .152.123.275.275.275zm4.4-2.2h.825a.275.275 0 0 1 0 .55h-.825a.275.275 0 1 1 0-.55zm0 1.1h.825a.275.275 0 0 1 0 .55h-.825a.275.275 0 1 1 0-.55zm-4.125-.55a.55.55 0 0 1 .55-.55h1.1a.55.55 0 0 1 .55.55v.55a.55.55 0 0 1-.55.55h-1.1a.55.55 0 0 1-.55-.55v-.55z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zak2gzhtda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 2.203)",
    d: "M0 0h15.4v15.4H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcomDelivery);
export default __webpack_public_path__ + "static/media/ecom-delivery.6c232ec5.svg";
export { ForwardRef as ReactComponent };